<a *ngIf="backConfig$ | async as config" rds-link standalone size="m" type="secondary" (click)="leavePageWarning && changesMade ? openLeavePageModal() : back()">
  <rds-icon namespace="filled" icon="chevron_left"></rds-icon>
  Back to {{config.label}}
</a>